<template>
  <ButtonStyle v-slot="{ classes }" :inverted="!active" :small="small">
    <a class="is-circle" :href="to" :class="classes">
      {{ page }}
    </a>
  </ButtonStyle>
</template>

<script lang="ts" setup>
defineProps<{
  active: boolean
  to: any
  page: number
  small: boolean
}>()
</script>
